import './bootstrap';
import router from './routes';

Vue.component('vorsi-toolbar', require('./components/Toolbar.vue').default);
Vue.component('vorsi-footer', require('./components/Footer.vue').default);
Vue.component('vorsi-headline', require('./homepage/components/Headline.vue').default);
Vue.component('vorsi-overview', require('./homepage/components/Overview.vue').default);
Vue.component('vorsi-services', require('./homepage/components/Services.vue').default);
Vue.component('vorsi-features', require('./homepage/components/Features.vue').default);

Vue.component('vorsi-pricing-headline', require('./pricing/components/Headline.vue').default);
Vue.component('vorsi-pricing-list', require('./pricing/components/PricingList.vue').default);
Vue.component('vorsi-essentials-list', require('./pricing/components/PricingLists/EssentialsList.vue').default);
Vue.component('vorsi-professional-list', require('./pricing/components/PricingLists/ProfessionalList.vue').default);
Vue.component('vorsi-business-list', require('./pricing/components/PricingLists/BusinessList.vue').default);
Vue.component('vorsi-enterprise-list', require('./pricing/components/PricingLists/EnterpriseList.vue').default);

Vue.component('vorsi-signup-form', require('./tryForFree/components/signUpForm.vue').default);

Vue.component('vorsi-two-factor-auth', require('./login/user/TwoFactorAuth.vue').default);

new Vue({
    el: '#app',
    router,
});
